// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/pages/DemoHistory.css */
.demo-history-container {
    padding: 24px;
    background: #f5f7fa;
    min-height: calc(100vh - 64px);
}

.page-header {
    margin-bottom: 32px;
    text-align: center;
}

.page-title {
    color: #1890ff;
    margin: 0;
    font-weight: 600;
    font-size: 24px;
}

.filter-card {
    margin-bottom: 24px;
    border-radius: 12px;
    background: #fff;
    box-shadow: 0 2px 16px rgba(0, 0, 0, 0.08);
    border: none;
    padding: 20px;
}

.filter-grid {
    display: grid;
    grid-template-columns: 2fr 1.5fr 1.5fr;
    gap: 16px;
    align-items: center;
}

.search-container {
    position: relative;
}

.search-box {
    display: flex;
    align-items: center;
    background: #f8f9fa;
    border-radius: 8px;
    padding: 4px 12px;
    border: 1px solid #e9ecef;
    transition: all 0.3s ease;
}

.search-box:hover {
    border-color: #ced4da;
}

.search-box:focus-within {
    border-color: #1890ff;
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}

.search-icon {
    color: #6c757d;
    font-size: 16px;
    margin-right: 8px;
}

.search-input {
    background: transparent;
    border: none;
    box-shadow: none !important;
    padding: 8px 0;
}

.search-input:focus {
    box-shadow: none !important;
}

.date-filter-container {
    position: relative;
}

.date-range-picker {
    display: flex;
    align-items: center;
    background: #f8f9fa;
    border-radius: 8px;
    padding: 4px 12px;
    border: 1px solid #e9ecef;
    transition: all 0.3s ease;
}

.date-range-picker:hover {
    border-color: #ced4da;
}

.date-icon {
    color: #6c757d;
    font-size: 16px;
    margin-right: 8px;
}

.date-picker {
    background: transparent;
    border: none;
    width: calc(100% - 30px);
}

.date-picker .ant-picker-input > input {
    font-size: 14px;
    color: #495057;
}

.course-filter-container .ant-select-selector {
    background: #f8f9fa !important;
    border: 1px solid #e9ecef !important;
    border-radius: 8px !important;
    height: 48px !important;
    padding: 4px 12px !important;
    transition: all 0.3s ease !important;
}

.course-filter-container .ant-select-selector:hover {
    border-color: #ced4da !important;
}

.course-filter-container .ant-select-focused .ant-select-selector {
    border-color: #1890ff !important;
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2) !important;
}

.select-placeholder {
    color: #6c757d;
    display: flex;
    align-items: center;
}

.table-card {
    border-radius: 12px;
    box-shadow: 0 2px 16px rgba(0, 0, 0, 0.08);
    border: none;
    overflow: hidden;
}

.demo-history-table {
    border-radius: 8px;
}

.demo-history-table .ant-table-thead > tr > th {
    background-color: #1890ff;
    color: white;
    font-weight: 600;
    white-space: nowrap;
}

.demo-history-table .ant-table-tbody > tr > td {
    white-space: normal;
    word-break: break-word;
}

.demo-history-table .ant-table-tbody > tr:hover > td {
    background-color: #e6f7ff !important;
}

.course-tag {
    max-width: 100%;
    white-space: normal;
    word-break: break-word;
    text-align: center;
    margin: 2px 0;
}

.email-cell, .message-cell {
    display: inline-block;
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

@media (max-width: 992px) {
    .filter-grid {
        grid-template-columns: 1fr;
        gap: 12px;
    }
    
    .search-box,
    .date-range-picker,
    .course-filter-container .ant-select-selector {
        height: 44px;
    }
}

@media (max-width: 768px) {
    .demo-history-container {
        padding: 16px;
    }
    
    .filter-card {
        padding: 16px;
    }
    
    .page-title {
        font-size: 20px;
    }
}`, "",{"version":3,"sources":["webpack://./src/MyComponents/ChatBot/DemoHistory.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,SAAS;IACT,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,0CAA0C;IAC1C,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sCAAsC;IACtC,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,8BAA8B;IAC9B,oCAAoC;IACpC,6BAA6B;IAC7B,uBAAuB;IACvB,4BAA4B;IAC5B,oCAAoC;AACxC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;IAChC,wDAAwD;AAC5D;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,0CAA0C;IAC1C,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI;QACI,0BAA0B;QAC1B,SAAS;IACb;;IAEA;;;QAGI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":["/* src/pages/DemoHistory.css */\n.demo-history-container {\n    padding: 24px;\n    background: #f5f7fa;\n    min-height: calc(100vh - 64px);\n}\n\n.page-header {\n    margin-bottom: 32px;\n    text-align: center;\n}\n\n.page-title {\n    color: #1890ff;\n    margin: 0;\n    font-weight: 600;\n    font-size: 24px;\n}\n\n.filter-card {\n    margin-bottom: 24px;\n    border-radius: 12px;\n    background: #fff;\n    box-shadow: 0 2px 16px rgba(0, 0, 0, 0.08);\n    border: none;\n    padding: 20px;\n}\n\n.filter-grid {\n    display: grid;\n    grid-template-columns: 2fr 1.5fr 1.5fr;\n    gap: 16px;\n    align-items: center;\n}\n\n.search-container {\n    position: relative;\n}\n\n.search-box {\n    display: flex;\n    align-items: center;\n    background: #f8f9fa;\n    border-radius: 8px;\n    padding: 4px 12px;\n    border: 1px solid #e9ecef;\n    transition: all 0.3s ease;\n}\n\n.search-box:hover {\n    border-color: #ced4da;\n}\n\n.search-box:focus-within {\n    border-color: #1890ff;\n    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);\n}\n\n.search-icon {\n    color: #6c757d;\n    font-size: 16px;\n    margin-right: 8px;\n}\n\n.search-input {\n    background: transparent;\n    border: none;\n    box-shadow: none !important;\n    padding: 8px 0;\n}\n\n.search-input:focus {\n    box-shadow: none !important;\n}\n\n.date-filter-container {\n    position: relative;\n}\n\n.date-range-picker {\n    display: flex;\n    align-items: center;\n    background: #f8f9fa;\n    border-radius: 8px;\n    padding: 4px 12px;\n    border: 1px solid #e9ecef;\n    transition: all 0.3s ease;\n}\n\n.date-range-picker:hover {\n    border-color: #ced4da;\n}\n\n.date-icon {\n    color: #6c757d;\n    font-size: 16px;\n    margin-right: 8px;\n}\n\n.date-picker {\n    background: transparent;\n    border: none;\n    width: calc(100% - 30px);\n}\n\n.date-picker .ant-picker-input > input {\n    font-size: 14px;\n    color: #495057;\n}\n\n.course-filter-container .ant-select-selector {\n    background: #f8f9fa !important;\n    border: 1px solid #e9ecef !important;\n    border-radius: 8px !important;\n    height: 48px !important;\n    padding: 4px 12px !important;\n    transition: all 0.3s ease !important;\n}\n\n.course-filter-container .ant-select-selector:hover {\n    border-color: #ced4da !important;\n}\n\n.course-filter-container .ant-select-focused .ant-select-selector {\n    border-color: #1890ff !important;\n    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2) !important;\n}\n\n.select-placeholder {\n    color: #6c757d;\n    display: flex;\n    align-items: center;\n}\n\n.table-card {\n    border-radius: 12px;\n    box-shadow: 0 2px 16px rgba(0, 0, 0, 0.08);\n    border: none;\n    overflow: hidden;\n}\n\n.demo-history-table {\n    border-radius: 8px;\n}\n\n.demo-history-table .ant-table-thead > tr > th {\n    background-color: #1890ff;\n    color: white;\n    font-weight: 600;\n    white-space: nowrap;\n}\n\n.demo-history-table .ant-table-tbody > tr > td {\n    white-space: normal;\n    word-break: break-word;\n}\n\n.demo-history-table .ant-table-tbody > tr:hover > td {\n    background-color: #e6f7ff !important;\n}\n\n.course-tag {\n    max-width: 100%;\n    white-space: normal;\n    word-break: break-word;\n    text-align: center;\n    margin: 2px 0;\n}\n\n.email-cell, .message-cell {\n    display: inline-block;\n    max-width: 100%;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n@media (max-width: 992px) {\n    .filter-grid {\n        grid-template-columns: 1fr;\n        gap: 12px;\n    }\n    \n    .search-box,\n    .date-range-picker,\n    .course-filter-container .ant-select-selector {\n        height: 44px;\n    }\n}\n\n@media (max-width: 768px) {\n    .demo-history-container {\n        padding: 16px;\n    }\n    \n    .filter-card {\n        padding: 16px;\n    }\n    \n    .page-title {\n        font-size: 20px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
